export default __webpack_public_path__ + "images/RateVector1.svg";